<div class="panel panel-default col-sm-5" style="margin-left: 100px; display: none" id="settingsSession">
  <div class="panel-heading">Session Policy</div>

    <div class="panel-body">

    <form class="form-horizontal">
      <div class="form-group">
        <label class="control-label col-sm-6">Timeout (minutes)</label>
        <div class="col-sm-6"><input class="form-control" type="text" name="timeout_in_minutes" [(ngModel)]="timeout_in_minutes"></div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-6">Warning Notice (minutes)</label>
        <div class="col-sm-6"><input class="form-control" type="text" name="prepare_time_in_minutes" [(ngModel)]="prepare_time_in_minutes"></div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-primary" (click)="updateSettingsSession()"><i class="fa fa-refresh" aria-hidden="true"></i> UPDATE</button>
      </div>

    </form>
  </div>
</div>
